import { InitialCausalityFilter } from '../../../../../../shared/types/typifications/initialCausality';

export const initialValues: InitialCausalityFilter = {
    active: true,
    category: '',
    consequence: '',
    motive: '',
    motiveDescription: '',
    motiveName: '',
    name: '',
    process: '',
    risk: '',
    riskId: '',
    riskImpact: '',
    sfcMotive: '',
    sfcMotiveClaim: '',
    sfcMotiveIdComplaint: '',
    sfcMotiveIdComplaintOld: '',
    sfcSubaccount: '',
    sfcSubmotive: '',
    submotive1: '',
    submotive2: '',
    submotive3: '',
    submotive4: '',
    subprocess: '',
    technicalBranch: '',
    typeComplaint: '',
    typeMotive: '',
    typePqr: '',
    unifiedProduct: '',
};
